module.exports = {"511525100":"文江镇","511525101":"庆符镇","511525102":"沙河镇","511525103":"嘉乐镇","511525104":"大窝镇","511525105":"罗场镇","511525106":"蕉村镇","511525107":"可久镇","511525108":"来复镇","511525109":"月江镇","511525110":"胜天镇","511525111":"复兴镇","511525203":"趱滩乡","511525204":"羊田乡","511525205":"落润乡","511525206":"潆溪乡","511525207":"庆岭乡","511525208":"双河乡","511525210":"四烈乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511525.json
// module id = 2177
// module chunks = 0